
export interface ProcurementWarehouse {
  id: string;
  procurement_id: string;
  warehouse_confirmed_by?: string;
  warehouse_rejected_by?: string;
  warehouse_confirmation_date?: string;
  warehouse_rejection_date?: string;
  warehouse_rejection_reason?: string;
  sample_taken?: boolean;
  damage_percentage?: number;
  net_kg_payable?: number;
  inspection_notes?: string;
  created_at: string;
  updated_at: string;
}

export interface CreateProcurementWarehouseInput extends Omit<ProcurementWarehouse, 'id' | 'created_at' | 'updated_at'> {}

export type WarehouseRejectionReason = 
  | 'quality_below_standards'
  | 'excessive_damage'
  | 'incorrect_product'
  | 'quantity_mismatch'
  | 'packaging_issues'
  | 'contamination'
  | 'storage_temperature_issues'
  | 'documentation_issues'
  | 'late_delivery'
  | 'other';

export const WAREHOUSE_REJECTION_REASONS: Record<WarehouseRejectionReason, string> = {
  quality_below_standards: 'Quality below standards',
  excessive_damage: 'Excessive damage',
  incorrect_product: 'Incorrect product',
  quantity_mismatch: 'Quantity mismatch',
  packaging_issues: 'Packaging issues',
  contamination: 'Contamination',
  storage_temperature_issues: 'Storage temperature issues',
  documentation_issues: 'Documentation issues',
  late_delivery: 'Late delivery',
  other: 'Other'
};
